


























































import { namespace } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import rest from '@/rest';
// interfaces
import { AiCreditUsageVm } from "@/interfaces/AiCreditUsageVm";
import { CustomizationVm } from '@/interfaces/CustomizationVm';

const customization = namespace("customization");

@Component({
  name: 'AiCostMeter'
})
export default class AiCostMeter extends Vue {
  @customization.Action loadCustomizationSettings!: any;
  @customization.Getter customizationSettings!: CustomizationVm;
  aiCreditUsage: AiCreditUsageVm | null = null;

  async mounted() {
    await this.loadCustomizationSettings();
    // console.log("Customization settings loaded in AiCostMeter:", this.customizationSettings);
    this.aiCreditUsage = await rest
      .url("contentManager/calculateAiCreditUsage")
      .get() as AiCreditUsageVm;
  }

  get totalUsedPercent() {
    if (!this.aiCreditUsage) return 0;
    return 100 - this.aiCreditUsage.remainingCreditBalanceInPercent;
  }

  get usageDetails() {
    if (!this.aiCreditUsage || this.aiCreditUsage.totalCostInCents === 0) return [];

    const total = this.aiCreditUsage.totalCostInCents;
    const calcPercent = (val: number) => {
      if (!total || total === 0) return 0;
      return Math.round((val / total) * 100);
    };
    const u = this.aiCreditUsage as any;

    return [
      { name: 'Text / Chat', percent: calcPercent(u.chatCostInCents || 0) },
      { name: 'Transkription', percent: calcPercent(u.transcriptionCostInCents || 0) },
      { name: 'Bildgenerierung', percent: calcPercent(u.imageGenerationCostInCents || 0) },
      { name: 'Videogenerierung', percent: calcPercent(u.videoGenerationCostInCents || 0) },
      { name: 'Text-to-Speech', percent: calcPercent(u.ttsGenerationCostInCents || 0) },
      { name: 'Podcastgenerierung', percent: calcPercent(u.podcastGenerationCostInCents || 0) },
      { name: 'Dokumentenanalyse', percent: calcPercent(u.docAnalysisCostInCents || 0) },
      { name: 'Bildanalyse', percent: calcPercent(u.imageAnalysisCostInCents || 0) },
    ]
    .filter(x => x.percent > 0)
    .sort((a, b) => b.percent - a.percent);
  }
}

